import Url from '@mc/mc-utils/js/url/url'
import { miniProgramEnv } from '@/defines/environment'

const getFromUrl = () => {
  const url = new Url(window.location.href)
  const { phone } = url.parseQuerystring()
  return phone
}

export const getPhone = userInfo => {
  if (userInfo.phone) {
    return userInfo.phone
  } else if (miniProgramEnv.isMiniProgram) {
    return getFromUrl()
  } else {
    return ''
  }
}
